'use client';

import type { InteractionType } from '~/model/InteractionType';
import { useTranslations } from 'next-intl';
import { ProjectFollowProvider } from '@/app/[locale]/(entity)/components/provider/ProjectFollowProvider';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { isMainUser } from '@/app/utils/entities/user';
import { BeardmanTalking } from '~/components/Beardman/BeardmanTalking/BeardmanTalking';
import { FollowedUpProjectBanner } from '~/components/Interaction/Thread/FollowedUpProjectBanner';

export const SurveyDefaultConclusion = ({ interaction }: { interaction: InteractionType }) => {
  const t = useTranslations('SURVEY');
  const { user } = useAuthenticatedContext();

  return (
    <div data-testid="survey-default-conclusion">
      <BeardmanTalking
        title={t('DEFAULT_CONCLUSION')}
        description={(
          <>
            {interaction && isMainUser(user) && (
              <ProjectFollowProvider project={interaction.project}>
                <FollowedUpProjectBanner inverse bottom />
              </ProjectFollowProvider>
            )}
          </>
        )}
      />
    </div>
  );
};
